<div class="tile">
  <h3 class="mb-3 font-size-3">{{ 'lombard.initial.headline' | transloco }}</h3>
  <p class="text-size-large">{{ 'lombard.initial.text' | transloco }}</p>
  @if (facade.lombard$ | async; as lombard) {
    <div class="row mt-4">
      <div class="col-12 col-lg-6 mb-3 mb-lg-0">
        <lombard-explanation [lombard]="lombard" />
      </div>
      <div class="col-12 col-lg-6">
        <lombard-conditions [lombard]="lombard" />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col text-size-large" [innerHTML]="'lombard.initial.legal' | transloco"></div>
    </div>
    <div class="row mt-2">
      <div class="col text-size-large">
        {{ 'lombard.initial.intermediation_agreement_pre_link_text' | transloco }}
        <a [href]="lombardIntermediationAgreementLink" target="_blank" rel="noopener noreferrer" class="link-secondary">{{
          'lombard.initial.intermediation_agreement_link_text' | transloco
        }}</a>
        {{ 'lombard.initial.intermediation_agreement_after_link_text' | transloco }}
      </div>
    </div>
    @if (lombard.maxCreditAmount && lombard.creditChangePossibleAmounts?.length) {
      <div class="row mt-4 align-items-end">
        <div class="col-12 col-lg-7 mb-3 mb-lg-0">
          <h5 class="text-bold mb-2">
            {{ 'lombard.initial.credit.headline' | transloco }}
            <svg class="icon icon-16 cursor-pointer" (click)="modal.open(modalContent, { size: 'lg' })">
              <use xlink:href="/assets/img/svgs/svgset.svg#info-23" />
            </svg>
          </h5>
          <div class="d-flex align-items-center justify-content-center justify-content-lg-start">
            @if (!isDropdownOpen) {
              <span class="text-size-important text-bold">{{ lombard.maxCreditAmount | currency: 'EUR' : 'symbol' : '1.0-0' }}</span>
              <svg class="icon icon-24 ml-2 cursor-pointer" (click)="toggleDropdown(lombard.creditChangePossibleAmounts[0])">
                <use xlink:href="/assets/img/svgs/svgset.svg#edit-23" />
              </svg>
            } @else {
              <div class="input-group-material select-dropdown">
                <select #creditLines (change)="handleDropdownChange($event, creditLines.value)">
                  @for (credit of lombard.creditChangePossibleAmounts; track $index) {
                    <option [value]="credit">{{ credit | currency: 'EUR' : 'symbol' : '1.0-0' }}</option>
                  }
                </select>
              </div>
            }
          </div>
        </div>
        <div class="col-12 col-lg-5 d-flex justify-content-center justify-content-lg-end">
          <web-design-system-button [disabled]="facade.applying$ | async" (click)="applyForCredit(lombard.maxCreditAmount)">
            {{ 'lombard.initial.button' | transloco }}
          </web-design-system-button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <web-components-user-messages />
        </div>
      </div>
    } @else {
      <div class="error-hint mt-4">
        {{ 'lombard.initial.error-hint' | transloco }}
      </div>
    }
  }
</div>

<ng-template #modalContent let-modal>
  <web-design-system-modal [headline]="'lombard.initial.modal.headline' | transloco" (dismiss)="modal.dismiss('Cross click')">
    {{ 'lombard.initial.modal.body' | transloco }}
  </web-design-system-modal>
</ng-template>
